document.addEventListener('scroll', function () {
  const header = document.querySelector('.header');
  if (window.scrollY > 50) {
    // 50px scroll threshold
    header.classList.add('header--scrolled');
  }
});
